import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Button from '../../components/Button/Button';
import Checkbox from '../../components/Checkbox/Checkbox';
import InputText from '../../components/Input/InputText';
import { session } from '../../helpers/helpers';
import { apiInstance } from '../../utils/api';

const ROUTES = {
  LOGIN: new URL(`${process.env.REACT_APP_API_URL}/auth/local`),
  VERIFY: new URL(`${process.env.REACT_APP_API_URL}/api/users/me`),
};

const Signin = () => {
  const [active, setActive] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const { push } = useHistory();

  useEffect(() => {
    const token = session.get('token');

    if (token) {
      // Если токен валиден, перенаправляем на главную страницу
      push('/');
    }
  }, [push]);

  const [loginLoading, setLoginLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();

    const eventTargetElements = Array.from(e.target.elements);
    const payload = eventTargetElements.reduce((acc, { value, name }) => {
      if (name) {
        acc[name] = value;
      }
      return acc;
    }, {});

    setLoginLoading(true);
    try {
      const data = await apiInstance(ROUTES.LOGIN, 'POST', payload);

      if (data?.jwt) {
        session.set('token', data.jwt); // Сохраняем токен в сессии
        push('/'); // Перенаправление
      } else {
        setLoginError(true);
        message.error('Неправильний логін чи пароль');
      }
    } catch (error) {
      setLoginError(true);
      message.error('Неправильний логін чи пароль');
    } finally {
      setLoginLoading(false);
    }
  };

  return (
    <div className="signin">
      <div className="signin__col signin__col_form">
        <a href="/" className="signin__link">
          <img src="/images/logo.svg" alt="logo" />
        </a>

        <div className="signin__inner">
          <div className="text-black-bold-f40-l48">Увійти</div>
          <div className="text-grey-dark-normal-f16-l28">
            Будь ласка, авторизуйтесь, щоб увійти до кабінету заявника.
          </div>

          <form onSubmit={(e) => login(e)} className="signin-form form">
            <InputText label="Email" id="identifier" autoFocus />

            <div style={{ position: 'relative' }}>
              <InputText type={showPassword ? 'text' : 'password'} label="Пароль" id="password" />
              <div
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '12px',
                  bottom: '10px',
                  cursor: 'pointer',
                  fontSize: '18px',
                  color: '#666',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {showPassword ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              </div>
            </div>

            <div className="signin-form__wrapper">
              <Checkbox checked={active} onClick={() => setActive(!active)} label="Запам'ятати" />

              <Link
                to="/recovery-password"
                className="text-turquoise-normal-f16-l28"
                style={{
                  transition: 'all 0.3s',
                  ...(loginError && {
                    animation: 'pulse-glow 2s ease-in-out infinite',
                    textShadow: '0 0 5px rgba(64, 224, 208, 0.5), 0 0 10px rgba(64, 224, 208, 0.3)',
                  }),
                }}
                onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.7')}
                onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
              >
                Не пам'ятаю пароль
              </Link>
            </div>

            <Button
              type="submit"
              text="Увійти"
              bg="pink"
              loading={loginLoading}
              loaderPosition="replace"
              loaderSize={20}
            />
          </form>

          <div className="text-grey-dark-normal-f16-l28">
            Хочете орендувати площу в ТРЦ Respublika Park?
          </div>
          <a className="text-turquoise-normal-f16-l28" href="/">
            Дізнайтесь як.
          </a>
        </div>
      </div>

      <div className="signin__col signin__col_banner" />
    </div>
  );
};

export default Signin;
